import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { StorageService } from '../../state-management/storage.service/storage.service';
import { ArchiveDataResponse, PaymentStatusResponse } from '../../../models/interfaces/response';
import { RedirectManagerService } from '../../state-management/redirect.service/redirect-manager.service';
import { Router } from '@angular/router';
import { TokenService } from '../../state-management/token.service/token.service';

@Injectable({
  providedIn: 'root'
})
export class PaymentApiService {
  private baseUrl = environment.apiUrl;
  artistId: string | number;

  redirectService = inject(RedirectManagerService);
  storageService = inject(StorageService);
  tokenService = inject(TokenService);
  http = inject(HttpClient);
  route = inject(Router);

  constructor() {
    this.artistId = this.storageService.getArtistId();
  }

  subscribeInAppPurchaseArtsSubscription(
    artIdList: any,
    paymentMethodId: string | null = null,
  ): Observable<any> {
    this.redirectService.saveRoute('onSubscribe', this.route.url);

    let params = new HttpParams()
      .set('artIdList', artIdList)
    if (paymentMethodId) {
      params = params.set('paymentMethodId', paymentMethodId);
    }
    const url = `${this.baseUrl}/subscribeInAppPurchaseArtsSubscription/`;
    return this.http.post(url, null, { params });
  }

  paymentStatus(sessionId: string | null): Observable<PaymentStatusResponse> {
    return this.http.get<PaymentStatusResponse>(`${this.baseUrl}/payment-status?sessionId=${sessionId}`);
  }

  cancelSubscription(planId: number): Observable<any> {
    return this.http.put(`${this.baseUrl}/cancelSubscriptionByPlanId/${planId}`, null);
  }


  cancelAlbumSubscription(planId: number): Observable<any> {
    return this.http.put(`${this.baseUrl}/cancelAlbumSubscriptionByPlanId/${planId}`, null);
  }


  tryPaymentAgain(uniqueSessionId: string): Observable<any> {
    const url = `${this.baseUrl}/tryAgain?uniqueSessionId=${uniqueSessionId}`;
    return this.http.put(url, null);
  }

  manageSubscriptions(limit: number = 5, page: number = 0): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set("no-loader", "yes");
    const url = `${this.baseUrl}/manageSubscriptions?limit=${limit}&page=${page}`;
    return this.http.get(url, { headers });
  }


  manageIndividualSubscriptions(limit: number = 5, page: number = 0): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set("no-loader", "yes");
    const url = `${this.baseUrl}/manageIndividualSubscriptions?limit=${limit}&page=${page}`;
    return this.http.get(url, { headers });
  }

  manageAlbumSubscriptions(limit: number = 5, page: number = 0): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set("no-loader", "yes");
    const url = `${this.baseUrl}/manageAlbumSubscriptions?limit=${limit}&page=${page}`;
    return this.http.get(url, { headers });
  }


  getArchivedSubscriptions(limit: number = 8, page: number = 0): Observable<ArchiveDataResponse> {
    let params = new HttpParams()
      .set("limit", limit)
      .set("page", page)

    if (this.artistId) {
      params = params.set("artistId", this.artistId);
    }

    let headers = new HttpHeaders();
    headers = headers.set("no-loader", "yes");
    return this.http.get<ArchiveDataResponse>(`${this.baseUrl}/getArchivedArts`, { params, headers });
  }

  getPlanArts(planId: number, limit = 10, page = 0): Observable<any> {
    const url = `${this.baseUrl}/getArtsByPlanId/${planId}?limit=${limit}&page=${page}`;
    return this.http.get(url);
  }

  getAlbumPlanArts(planId: number, limit = 10, page = 0): Observable<any> {
    const url = `${this.baseUrl}/getSubscribedAlbumByAlbumId/${planId}?limit=${limit}&page=${page}`;
    return this.http.get(url);
  }

  resumeSubscription(planId: number) {
    return this.http.get(`${this.baseUrl}/getArtsByPlanId/${planId}`);
  }

  subscribeWithCard(stripeSubscriptionId: string): Observable<any> {
    const params = new HttpParams().set("stripeSubscriptionId", stripeSubscriptionId);
    return this.http.get(`${this.baseUrl}/payment-status_subscription`, { params });
  }
}
